import React, { useState } from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { CheckInModal } from './CheckInModal';
import { AppData } from '../../types';
import { formatDateTime } from '../../utils/dateFormat';
import { Plus, HeartPulse } from 'lucide-react';
interface CheckInsTabProps {
  data: AppData;
  onAddCheckIn: (checkin: any) => void;
}
export function CheckInsTab({
  data,
  onAddCheckIn
}: CheckInsTabProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const getMoodColor = (mood: string) => {
    switch (mood) {
      case 'Great':
        return 'bg-green-100 text-green-800';
      case 'Good':
        return 'bg-blue-100 text-blue-800';
      case 'Okay':
        return 'bg-yellow-100 text-yellow-800';
      case 'Bad':
        return 'bg-orange-100 text-orange-800';
      case 'Terrible':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  return <div className="space-y-6 max-w-5xl mx-auto" data-id="element-20">
      <div className="flex justify-between items-center" data-id="element-21">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-22">
          Health & Impact Check-ins
        </h2>
        <Button onClick={() => setIsModalOpen(true)} leftIcon={<Plus className="w-4 h-4" data-id="element-24" />} data-id="element-23">
          New Check-in
        </Button>
      </div>

      {data.checkins.length === 0 ? <div className="text-center py-12 bg-gray-50 rounded-xl border-2 border-dashed border-gray-200" data-id="element-25">
          <p className="text-gray-500 mb-4" data-id="element-26">No check-ins logged yet</p>
          <Button variant="secondary" onClick={() => setIsModalOpen(true)} data-id="element-27">
            Log Your First Check-in
          </Button>
        </div> : <div className="grid gap-4" data-id="element-28">
          {data.checkins.map(checkin => <Card key={checkin.id} hover data-id="element-29">
              <div className="flex flex-col sm:flex-row gap-6" data-id="element-30">
                <div className="flex flex-col items-center justify-center min-w-[100px]" data-id="element-31">
                  <span className="text-4xl mb-2" data-id="element-32">
                    {checkin.mood === 'Great' ? '😊' : checkin.mood === 'Good' ? '🙂' : checkin.mood === 'Okay' ? '😐' : checkin.mood === 'Bad' ? '😔' : '😢'}
                  </span>
                  <span className={`px-3 py-1 rounded-full text-xs font-bold ${getMoodColor(checkin.mood)}`} data-id="element-33">
                    {checkin.mood}
                  </span>
                </div>

                <div className="flex-1 space-y-3" data-id="element-34">
                  <div className="text-sm text-gray-500 font-medium" data-id="element-35">
                    {formatDateTime(checkin.timestamp)}
                  </div>

                  <div className="grid sm:grid-cols-2 gap-4" data-id="element-36">
                    {checkin.symptoms && <div className="bg-red-50 p-3 rounded-lg" data-id="element-37">
                        <p className="text-xs font-bold text-red-800 uppercase mb-1" data-id="element-38">
                          Physical Symptoms
                        </p>
                        <p className="text-sm text-gray-800" data-id="element-39">
                          {checkin.symptoms}
                        </p>
                      </div>}
                    {checkin.emotionalImpact && <div className="bg-purple-50 p-3 rounded-lg" data-id="element-40">
                        <p className="text-xs font-bold text-purple-800 uppercase mb-1" data-id="element-41">
                          Emotional Impact
                        </p>
                        <p className="text-sm text-gray-800" data-id="element-42">
                          {checkin.emotionalImpact}
                        </p>
                      </div>}
                  </div>

                  {checkin.notes && <p className="text-sm text-gray-600 italic border-l-2 border-gray-200 pl-3" data-id="element-43">
                      "{checkin.notes}"
                    </p>}
                </div>
              </div>
            </Card>)}
        </div>}

      <CheckInModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onSave={onAddCheckIn} data-id="element-44" />
    </div>;
}